<template>
    <FKBreadCrumb :page="survey_name">
        <FKBreadCrumbItem :page="$t('page.patients')" to="/patients" />
        <FKBreadCrumbItem :page="$t('page.patient')" :to="`/patient/${patient_id}`" />
    </FKBreadCrumb>
    <SurveyView :survey="survey" :patient_id="patient_id!"/>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import SurveyView from "@/components/FK/Surveys/SurveyView.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import { Survey } from "@/utils/models/survey.model";

export default defineComponent({
    name: "SurveyPage",
    components: {
        FKBreadCrumb,
        FKBreadCrumbItem,
        SurveyView
    },
    data() {
        return {
            survey: this.$route.meta.survey as Survey,
        }
    },
    computed: {
        survey_name() { return (this.$route.meta.survey as Survey)?.title ?? this.$t('page.surveys')},
        patient_id(): string { return this.$route.params.id as string }
    }
});
</script>